import { paginatedQuery } from 'lib-shared-api-utils';
import { api } from 'utils/apis/api';
export const numbersApi = api.injectEndpoints({
    endpoints: (builder) => ({
        readNumbers: builder.query({
            query: (arg) => paginatedQuery(arg, ({ capability }) => ({
                version: 1,
                path: 'numbers',
                params: { sms_capable: capability === 'sms' ? 'true' : undefined },
            }), { pagination: { paramNaming: 'limitCount' } }),
        }),
        readDefaultNumber: builder.query({
            query: () => ({
                version: 1,
                path: 'numbers/default',
            }),
        }),
        readValidateNumber: builder.query({
            query: ({ phoneNumber }) => ({
                version: 1,
                path: `numbers/validate/${phoneNumber}`,
            }),
        }),
        updateNumber: builder.mutation({
            query: ({ phoneNumber, data: body }) => ({
                version: 1,
                path: `numbers/${phoneNumber}`,
                method: 'PUT',
                body,
            }),
        }),
    }),
});
